import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OnlineBadge from '../components/OnlineBadge';
import BottomNav from '../components/BottomNav';
import { listOutbox, removeOutbox, onOutboxChange, type OutboxItem } from '../db/outbox';
import { flushOutbox } from '../sync/submit';
import { fmtDateTime } from '../lib/format';
import { ago } from '../lib/statusUi';

export default function PendingSyncs() {
  const nav = useNavigate();
  const [items, setItems] = useState<OutboxItem[]>([]);
  const [busy, setBusy] = useState(false);

  const load = () => listOutbox().then(setItems).catch(() => {});
  useEffect(() => { load(); return onOutboxChange(load); }, []);

  async function retry() {
    setBusy(true);
    try { await flushOutbox(); } finally { setBusy(false); load(); }
  }

  return (
    <div className="app has-bottomnav">
      <OnlineBadge />
      <h1>Pending readings</h1>

      {items.length === 0 && (
        <div className="empty">
          <div className="ic">✓</div>
          Everything is synced.
        </div>
      )}

      <div className="cardlist">
        {items.map((it) => {
          const tone = it.status === 'rejected' ? 'bad' : it.status === 'synced' ? 'ok' : 'warn';
          return (
            <div key={it.submissionId} className="item">
              <div className={`stripe ${tone}`} />
              <div className="body">
                <div className="spread">
                  <span className="title">{it.equipmentName}</span>
                  <span className={`chip ${tone === 'bad' ? 'bad' : tone === 'ok' ? 'ok' : 'warn'}`}>
                    {it.status === 'pending' ? 'Waiting' : it.status === 'syncing' ? 'Syncing…' : it.status === 'synced' ? 'Synced' : 'Rejected'}
                  </span>
                </div>
                <div className="meta">
                  <span>Captured {ago(it.clientCapturedAt)}</span>
                  <span>{it.operatorName}</span>
                  {it.attempts > 0 && <span>{it.attempts} attempts</span>}
                </div>
                {it.rejectReason && <p className="error tiny" style={{ marginTop: 6 }}>{it.rejectReason}</p>}
                {it.lastError && !it.rejectReason && <p className="muted tiny" style={{ marginTop: 6 }}>Last: {it.lastError}</p>}
                {it.status === 'rejected' && (
                  <button className="secondary xs" style={{ marginTop: 8 }} onClick={() => removeOutbox(it.submissionId)}>Dismiss</button>
                )}
                <div className="muted tiny" style={{ marginTop: 6 }}>{fmtDateTime(it.clientCapturedAt)}</div>
              </div>
            </div>
          );
        })}
      </div>

      <button onClick={retry} disabled={busy || navigator.onLine === false}>
        {busy ? 'Syncing…' : 'Sync now'}
      </button>
      <button className="secondary" onClick={() => nav('/')}>Back</button>

      <BottomNav />
    </div>
  );
}
